import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { safeRest } from '@tds/util-helpers';
import { or, componentWithName } from '@tds/util-prop-types';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

var StyledA11yContent = styled.span.withConfig({
  displayName: "A11yContent__StyledA11yContent",
  componentId: "sc-15wexwk-0"
})({
  position: 'absolute',
  height: '1px',
  width: '1px',
  overflow: 'hidden',
  clip: 'rect(1px, 1px, 1px, 1px)'
});
/**
 * @version ./package.json
 */

var A11yContent = function A11yContent(_ref) {
  var children = _ref.children,
      rest = objectWithoutProperties(_ref, ["children"]);

  return React.createElement(StyledA11yContent, safeRest(rest), children);
};

A11yContent.propTypes = {
  /**
   * Accessible content. Can be either a string or a `Heading` Component
   */
  children: or([PropTypes.string, componentWithName('Heading')]).isRequired
};
A11yContent.defaultProps = {};

export default A11yContent;
